"use strict";

exports.__esModule = true;
var metadata = {
  stage: 3
};
exports.metadata = metadata;


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/lib/transformation/transformers/es7/async-functions.js
// module id = 2105
// module chunks = 0